<template>
    <div>
        <kgr-loading
            v-if="loading"
            inline
        />
        <div v-else-if="isDogModuleActive">
            <div class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('Hundeanmeldung') }}
            </div>
            <div class="kgr-row">
                <kgr-form-row
                    v-model="clubDogMemberConfiguration.askDogs"
                    :error="error"
                    :label="$t('Hundeanmeldung aktivieren')"
                    field-name="askDogs"
                >
                    <kgr-checkbox
                        v-model="clubDogMemberConfiguration.askDogs"
                        :label="$t('Soll das Mitglied selbst Hunde anlegen dürfen?')"
                    />
                </kgr-form-row>
            </div>
            <template  v-if="clubDogMemberConfiguration.askDogs">
                <hr class="kgr-separator kgr-separator--light" />
                <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">{{ $t('Hund anlegen') }}</h3>
                <div class="kgr-row">
                    <kgr-form-row
                        :label="$t('Einleitungstext für die Hundeanmeldung (bis zu 1.000 Zeichen)')"
                        :error="error"
                        field-name="dogsIntro"
                    >
                        <kgr-editor-mini
                            v-model="clubDogMemberConfiguration.dogsIntro"
                            editor-id="dogs"
                            height="150"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-row">
                    <kgr-form-row
                        v-model="clubDogMemberConfiguration.dogChipNumberMandatory"
                        :error="error"
                        field-name="dogChipNumberMandatory"
                    >
                        <kgr-checkbox
                            v-model="clubDogMemberConfiguration.dogChipNumberMandatory"
                            :label="$t('Ist die Eingabe der Chipnummer verpflichtend?')"
                        />
                    </kgr-form-row>
                    <kgr-form-row
                        :error="error"
                        field-name="dogBreedingBookNumberMandatory"
                    >
                        <kgr-checkbox
                            v-model="clubDogMemberConfiguration.dogBreedingBookNumberMandatory"
                            :label="$t('Ist die Eingabe der Zuchtbuchnummer verpflichtend?')"
                        />
                    </kgr-form-row>
                </div>
                <hr class="kgr-separator kgr-separator--light" />
                <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">{{ $t('Datei-Upload') }}</h3>
                <div class="kgr-row">
                    <kgr-form-row
                        :label="$t('Einleitungstext für den Datei-Upload (bis zu 1.000 Zeichen)')"
                        :error="error"
                        field-name="fileUploadIntro"
                    >
                        <kgr-editor-mini
                            v-model="clubDogMemberConfiguration.fileUploadIntro"
                            editor-id="fileUpload"
                            height="150"
                        />
                    </kgr-form-row>
                </div>
            </template>
        </div>
        <div
            v-if="isEditable"
            class="kgr-text kgr-text--rightAligned mt1"
        >
            <kgr-button
                :value="$t('Speichern')"
                @click="save()"
            />
        </div>
    </div>
</template>

<script>

import Checkbox from '../../../../components/common/form/checkbox/Checkbox.vue';
import ClubDogMemberConfigurationRepository from '../../../../js/repository/ClubDogMemberConfigurationRepository';
import Error from '../../../../js/model/Error';
import FormRow from '../../../../components/common/form/FormRow.vue';
import KgrButton from '../../../../components/common/form/button/KgrButton.vue';
import Loading from '../../../../components/common/Loading';
import WysiwygEditorMini from '../../../../components/WysiwygEditorMini.vue';

export default {
    components: {
        'kgr-editor-mini': WysiwygEditorMini,
        'kgr-loading': Loading,
        'kgr-checkbox': Checkbox,
        'kgr-button': KgrButton,
        'kgr-form-row': FormRow,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDogModuleActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubDogMemberConfiguration: null,
            error: new Error(),
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            ClubDogMemberConfigurationRepository.find(this.clubId)
                .then(clubDogMemberConfiguration => {
                    this.clubDogMemberConfiguration = clubDogMemberConfiguration;
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        save() {
            this.error = new Error();
            this.paymentAccordionHasError = false;
            ClubDogMemberConfigurationRepository.update(this.clubId, this.clubDogMemberConfiguration)
                .then(() => this.$notify.success('Die Änderungen wurden erfolgreich gespeichert.'))
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('Die Änderungen konnten nicht gespeichert werden.');
                });
        },
    },
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
</style>
